import { ROUTES } from "@/shared/constants/routes";

interface SessionShape {
  tenant: unknown;
  pendingInvites: readonly unknown[];
}

/**
 * Where a signed-in user belongs (ADR-0011): inside an organisation → overview; invited somewhere → the
 * invitations page; otherwise → create one. Used after verify, accept, create and by the route guards.
 */
export function postLoginDestination(session: SessionShape): string {
  if (session.tenant) return ROUTES.overview;
  if (session.pendingInvites.length > 0) return ROUTES.onboardingInvitations;
  return ROUTES.onboardingCreateOrganisation;
}

/** A `from` location is honoured only when it is an in-app path that is not the login page itself. */
export function returnPath(state: unknown, fallback: string): string {
  const from = (state as { from?: unknown } | null)?.from;
  return typeof from === "string" && from.startsWith("/") && !from.startsWith(ROUTES.login) ? from : fallback;
}

/**
 * Why the session ended, when the api said (ADR-0011 addendum 2026-10-04): the sign-in page says it in
 * one sentence instead of a bare form. The client puts the 401's code in the router state as `reason`;
 * a plain `UNAUTHORIZED` (signed out, expired, revoked) needs no sentence.
 */
export function sessionEndedSentence(state: unknown): string | null {
  const reason = (state as { reason?: unknown } | null)?.reason;
  if (reason === "MEMBERSHIP_INACTIVE") return "Your access to this organisation has been turned off.";
  if (reason === "TENANT_DELETED") return "This organisation has been deleted.";
  return null;
}
